/**
 * PayFastWebhookService
 * Service for PayFast webhook operations
 * Route: api/payfast-webhook
 * Controller: PayFastWebhookController.cs
 */
import { BaseService } from '../base/BaseService';
/**
 * PayFastWebhookService
 * Handles PayFast webhook operations
 * Maps to /api/payfast-webhook endpoint
 * Note: This is typically a webhook receiver, not a standard CRUD service
 */
export class PayFastWebhookService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PayFastWebhookService.DEFAULT_SERVICE_PATH,
            basePath: PayFastWebhookService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Process PayFast webhook notification
     * POST /api/payfast-webhook
     * @param payload - Webhook payload from PayFast
     * @returns Processing result
     */
    async processWebhook(payload) {
        const response = await this.processWebhookRaw(payload);
        return response.data ?? false;
    }
    /**
     * Process PayFast webhook notification (raw)
     * @param payload - Webhook payload from PayFast
     * @returns ResponseData with processing result
     */
    processWebhookRaw(payload) {
        const url = this.buildUrl();
        return this.http.post(url, payload);
    }
}
PayFastWebhookService.DEFAULT_SERVICE_PATH = 'payments';
PayFastWebhookService.BASE_PATH = 'api/payfast-webhook';
//# sourceMappingURL=PayFastWebhookService.js.map